import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatDialogRef } from '@angular/material/dialog';
import { TemplateService } from '../../services/template.service';
import { FileService } from 'app/modules/common/services/file.service';
import { FileFormatEnum } from 'app/modules/common/enums/file-format-enum';

@Component({
    selector: 'app-add-cittemplate',
    templateUrl: './add-template.component.html',
    styleUrls: ['./add-template.component.scss'],
    standalone: false
})
export class AddTemplateComponent implements OnInit {

    @Input() IsUpdate = false;
    @Input() Template = null;
    @Input() TemplateFile = null;

    public templateTitle = 'Nuevo Plantilla';

    templateFormGroup: UntypedFormGroup;
    IsSaving = false;

    public FileFormatEnum = FileFormatEnum;

    @Output() saved: EventEmitter<void> = new EventEmitter();
    file: any;
    constructor(
        public fb: UntypedFormBuilder,
        private sharedService: SharedService,
        public dialogRef: MatDialogRef<AddTemplateComponent>,
        private templateService: TemplateService,
        private fileService: FileService
    ) { }

    ngOnInit(): void {
        this.initForm();
        if (this.IsUpdate) {
            this.templateTitle = 'Editar plantilla';
        }
    }

    private initForm(): void {
        const uploadPath = 'Plantillas\\CartaPD';
        let id = 0;
        let name = '';
        let document = null;

        if (this.IsUpdate) {
            id = this.Template.plantillaId;
            name = this.Template.nombre;
            document = this.TemplateFile;
        }

        this.templateFormGroup = this.fb.group({
            'plantillaId': [id],
            'nombre': [name, Validators.required],
            'path': [uploadPath, Validators.required],
            'documentInBase64': [document, Validators.required]
        });
    }

    public addDocument(): void {
        this.templateFormGroup.get('nombre').markAsTouched();
        this.templateFormGroup.get('path').markAsTouched();
        this.templateFormGroup.get('documentInBase64').markAsTouched();
        let id = 0;

        if (this.Template !== null) {
            id = this.Template.plantillaId;
        }

        const fileType = this.templateFormGroup.get('nombre').value;
        const extension = fileType.split('.').pop()

        if (!FileFormatEnum.CitationController.includes(extension)) {
            this.sharedService.ShowSnackBar('Formato de fichero no permitido: ' + extension.ToString(), '', 2500);
            return;
        }

        if (this.templateFormGroup.valid) {

            this.IsSaving = true;
            const model = this.templateFormGroup.value;
            model.plantillaId = id;
            this.templateService.saveNewTemplate(model)
                .subscribe(resp => {
                    this.IsSaving = false;
                    this.sharedService.ShowSnackBar('Guardado con éxito', '', 2500);
                    this.templateFormGroup.reset();
                    this.saved.emit();
                    this.dialogRef.close();
                }, err => {
                    this.IsSaving = false;
                    console.error('no se puede guardar');
                });
        }
    }

    uploadFile(event): void {
        this.readFile(event[0]);
    }

    private readFile(file): void {
        const fileReader = new FileReader();
        fileReader.onload = (event) => {
            this.file = file.name;
            const name = file.name;
            const inputName = this.templateFormGroup.get('nombre').value;
            if (inputName === '' || inputName === undefined || inputName === null) {
                this.templateFormGroup.get('nombre').patchValue(name);
            }

            this.templateFormGroup.get('documentInBase64').patchValue(this.fileService.arrayBufferToBase64(fileReader.result));
        };

        if (FileFormatEnum.CitationControllerTS.includes(this.fileService.getFileExtention(file.type))) {
            fileReader.readAsArrayBuffer(file);
        }
        else {
            this.sharedService.ShowSnackBar('No se puede aceptar este tipo de archivo', 'Okay', 1500);
        }
    }

    public cancel(): void {
        this.dialogRef.close();
    }
}
